import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, IconButton, Typography, useMediaQuery } from "@mui/material";
import Modal from "@mui/material/Modal";
import React from "react";
import parse from "html-react-parser";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import checkIcon from "../../assets/images/circle-check.png";
import errorIcon from "../../assets/images/octagon-xmark.svg";
import warningIcon from "../../assets/images/triangle-exclamation.png";
import { ModalActionProps } from "../../interfaces/props/ModalActionProps";
import "./styles.css";
import {
  sxButton,
  sxButtonContained,
  sxCloseIconButton,
  sxTextButton,
  sxTypographySubTitle,
  sxTypographyTitle,
} from "./sxProps";

const ModalAction: React.FC<ModalActionProps> = ({
  showModal,
  handleShowModal,
  maxWidth,
  title,
  subTitle,
  icon,
  colorContainedButton,
  textContainedButton,
  textOutlinedButton,
  handleContainedButton,
  handleOutlinedButton,
}) => {
  const {
    textStyleAccessibility,
    buttonStyleAccessibility,
    buttonTextStyleAccessibility,
  } = useAccessibility();
  const mobileScreen = useMediaQuery("(max-width: 999px)");

  const selecionarIcone = (icon: 'error' | 'success' | 'warning'): string => {
    switch (icon) {
      case "success":
        return checkIcon;
      case "error":
        return errorIcon;
      case "warning":
        return warningIcon;
      default:
        return checkIcon;
    }
  };

  const getColorContainedButton = (
    icon: "error" | "success" | "warning" | undefined
  ): "error" | "success" | "warning" => {
    if (colorContainedButton) return colorContainedButton;
    switch (icon) {
      case "error":
      case "warning":
        return "error";
      case "success":
        return "success";
      default:
        return "success";
    }
  };

  const outlinedButton = (
    <Button
      style={buttonStyleAccessibility}
      onClick={handleOutlinedButton}
      sx={sxButton}
      variant={"outlined"}
    >
      <Typography style={buttonTextStyleAccessibility} sx={sxTextButton}>
        {textOutlinedButton}
      </Typography>
    </Button>
  );

  const containedButton = (
    <Button
      style={buttonStyleAccessibility}
      onClick={handleContainedButton}
      sx={{
        ...sxButtonContained,
        background:
          getColorContainedButton(icon) === "error" ? "#d32f2f" : "#00995D",
        "&:hover": {
          background:
            getColorContainedButton(icon) === "error" ? "#8F1131" : "#164029",
        },
      }}
      variant={"contained"}
      color={getColorContainedButton(icon)}
    >
      <Typography
        style={{ ...buttonTextStyleAccessibility, color: "#fff" }}
        sx={sxTextButton}
      >
        {textContainedButton}
      </Typography>
    </Button>
  );

  return (
    <div>
      <Modal open={showModal} onClose={handleShowModal}>
        <div style={{...textStyleAccessibility, maxWidth: maxWidth}} className="container-modal-action">
          <IconButton
            aria-label="fechar"
            onClick={handleShowModal}
            sx={sxCloseIconButton}
          >
            <FontAwesomeIcon icon={faTimes} size="1x" color="black" />
          </IconButton>
          {icon && (
            <div>
              <img src={selecionarIcone(icon)} alt="" />
            </div>
          )}
          <Typography sx={sxTypographyTitle} component="h1">{title}</Typography>
          <div className="modal-typography-scroll">
            <Typography sx={sxTypographySubTitle}>{parse(String(subTitle || ""))}</Typography>
          </div>
          <div className="action-modal-buttons-holder">
            {mobileScreen ? containedButton : outlinedButton}
            {mobileScreen ? outlinedButton : containedButton}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ModalAction;
